import { CreateButton } from '@/components';
import type { FC } from 'react';
import { useHierarchyLabelsDrawerState } from './hierarchy-label/DrawerStateProvider';

export const CreateHierarchyLabelButton: FC = () => {
  const { setDrawerState } = useHierarchyLabelsDrawerState();
  return (
    <CreateButton
      onCreate={() => {
        setDrawerState({ open: true, isEditing: false });
      }}
    />
  );
};
